import { useCallback } from "react";

import ky from "ky";
import { Options } from "ky";

const retryStatusCodes = [401, 404, 408, 413, 429, 500, 502, 503, 504];

export default function useFetch() {
  const get = useCallback(
    async (
      url: string,
      token: string,
      renewToken: Function,
      options?: Options
    ) => {
      return await ky
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          retry: {
            limit: 3,
            methods: ["get"],
            statusCodes: retryStatusCodes,
          },
          hooks: {
            afterResponse: [
              async (request, options, response) => {
                if (response.status === 401) {
                  const token = await renewToken();
                  request.headers.set("Authorization", `Bearer ${token}`);
                  return ky(request);
                }
              },
            ],
          },
          timeout: false,
          ...options,
        })
        .json();
    },
    []
  );

  const create = async (
    url: string,
    json: any,
    token: string,
    renewToken: Function,
    options?: Options
  ) => {
    return await ky
      .post(url, {
        ...(json && { json }),
        headers: {
          Authorization: `Bearer ${token}`,
        },
        retry: {
          limit: 3,
          methods: ["post"],
          statusCodes: retryStatusCodes,
        },
        hooks: {
          afterResponse: [
            async (request, options, response) => {
              if (response.status === 401) {
                const token = await renewToken();
                request.headers.set("Authorization", `Bearer ${token}`);
                return ky(request);
              }
            },
          ],
        },
        timeout: false,
        ...options,
      })
      .json();
  };

  const update = async (
    url: string,
    json: any,
    token: string,
    renewToken: Function,
    options?: Options
  ) => {
    return await ky
      .patch(url, {
        json,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        retry: {
          limit: 3,
          methods: ["patch"],
          statusCodes: retryStatusCodes,
        },
        hooks: {
          afterResponse: [
            async (request, options, response) => {
              if (response.status === 401) {
                const token = await renewToken();
                request.headers.set("Authorization", `Bearer ${token}`);
                return ky(request);
              }
            },
          ],
        },
        timeout: false,
        ...options,
      })
      .json();
  };

  const remove = async (
    url: string,
    token: string,
    renewToken: Function,
    options?: Options
  ) => {
    return await ky
      .delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        retry: {
          limit: 3,
          methods: ["delete"],
          statusCodes: retryStatusCodes,
        },
        hooks: {
          afterResponse: [
            async (request, options, response) => {
              if (response.status === 401) {
                const token = await renewToken();
                request.headers.set("Authorization", `Bearer ${token}`);
                return ky(request);
              }
            },
          ],
        },
        timeout: false,
        ...options,
      })
      .json();
  };

  return {
    get,
    create,
    update,
    remove,
  };
}
